export default __webpack_public_path__ + "static/maria nunkester-66cc82eb99a5c40f589c79e676b9d74f.png";